import { customElement } from 'lit/decorators.js';
import { css } from 'lit';
import { tagName } from '../../../helpers';
import { MediaPlayerBaseComponent } from '../media-player.component';

const tag = tagName('video-player');

@customElement(tag)
export class MediaPlayerVideoComponent extends MediaPlayerBaseComponent {
  static override styles = css`
    :host {
      display: block;
      inline-size: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'a-video-player': MediaPlayerVideoComponent;
  }
}
